import { app } from '../../app.module'
app
  /**
   * CSVダウンロード用のディレクティブ
   * ボタン押下時にデータをダウンロードし、CSVファイルとして出力する
   * Safariではng-csvが正常に動作しないため、Safariの場合はクリックできないようにする
   * attribute: type {string} ダウンロードするデータの種類(post, account等)
   * attribute: snsType {string} ダウンロードするデータのSNS種別
   * attribute: subName {string} CSVファイル名に追加する種別の名前。イベント名や、ランキングの種類を記載する
   */
  .directive('csvDownload', () => {
    return {
      restrict: 'E',
      template: require('./csv-download.pug')(),
      scope: {
        type: '@',
        snsType: '=',
        subName: '=',
        analyticsTab: '=',
        accountFollowerConfig: '=',
        accountId: '=',
        accountUsername: '=',
      },
      controller: function ($window, $scope, $q, $state, csvDownloadService, $rootScope) {
        // CSVダウンロード中フラグ
        $scope.isCsvDownloading = false
        let csvFile = ''
        let initCsv = true

        // ブラウザがSafariの場合、CSVダウンロードボタンをdisabledにする
        if (
          $window.navigator.userAgent.indexOf('Safari') > 0 &&
          $window.navigator.userAgent.indexOf('Chrome') < 0
        ) {
          $scope.disableCsv = true
          $scope.tooltipMessage = 'Safariでは、CSVダウンロードを行うことはできません。'
        } else if ($rootScope.groupStatus === 0) {
          // デモ利用の場合、CSVダウンロードボタンをdisabledにする
          $scope.disableCsv = true
          $scope.tooltipMessage = 'トライアル利用中はCSVダウンロードを行うことはできません。'
        } else {
          // Safari以外はCSVダウンロードを有効にする
          $scope.disableCsv = false
          $scope.tooltipMessage = 'CSVダウンロード'

          // ダウンロードボタン押下時ににファイル名を生成しても反映されないため、
          // 事前にファイル名を生成しておく
          createCSVFileName()

          // date-pickerの範囲をファイル名に含めるため、日付の変更を監視
          const removeEvent = $rootScope.$on('changeDateRange', () => {
            createCSVFileName()
          })

          // ディレクティブが消える際には、$rootScopeのイベントの監視を削除
          $scope.$on('$destroy', () => {
            removeEvent()
          })

          // イベント投稿モーダルにて、SNSタブの選択を検知
          $scope.$watch(
            () => {
              return $scope.snsType
            },
            () => {
              if ($scope.snsType !== undefined) {
                createCSVFileName()
              }
            }
          )

          // 分析タブの選択を検知
          $scope.$watch(
            () => {
              return $scope.analyticsTab
            },
            () => {
              if (initCsv === true) {
                initCsv = false
                return
              }

              if (
                $scope.analyticsTab !== undefined &&
                $scope.analyticsTab !== 'change' &&
                $scope.analyticsTab !== 'post'
              ) {
                createCSVFileName()
              }
            }
          )

          // 1投稿あたりの平均スイッチ変化を検知
          $scope.$watch(
            () => {
              return $scope.$parent.dataPerPostFlg
            },
            () => {
              if ($scope.$parent.snsType === 'tiktok') {
                createCSVFileName()
              }
            }
          )

          $rootScope.$on('changeParamPost', (event, data) => {
            $scope.accountPostParams = data.getOptions
          })
        }

        /**
         * CSVファイル名を生成
         */
        function createCSVFileName() {
          let extension = ''

          // 選択した期間を文字列にする
          if (
            $scope.$parent.getOptions !== undefined &&
            $scope.$parent.getOptions.startEndDate !== undefined
          ) {
            extension =
              moment.unix($scope.$parent.getOptions.startEndDate.startDate).format('YYYY-MM-DD') +
              '_'
            extension += moment
              .unix($scope.$parent.getOptions.startEndDate.endDate)
              .format('YYYY-MM-DD')
          }

          // attributeごとに、CSVファイル名を整形する
          switch ($scope.type) {
            case 'post':
            case 'account':
              csvFile = $scope.type + '_' + $scope.$parent.selectedTab
              break
            case 'event':
              csvFile = $scope.type + '_' + $scope.snsType
              break
            case 'tw_trendword':
            case 'yahoo_word':
              csvFile = $scope.type
              break
            case 'brand_followers':
              csvFile = $scope.type
              break
            default:
              if ($scope.type === 'account_target') {
                // アカウントの投稿の対象の場合
                csvFile = $scope.type + '_' + $scope.analyticsTab

                if ($scope.$parent.snsType === 'tiktok') {
                  csvFile = 'post' + '_' + $scope.analyticsTab
                }
              } else {
                csvFile = $scope.type
              }

              // アカウント詳細モーダルの場合、usernameをセット、usernameがない場合はaccountIdをセット
              if ($state.current === undefined || $state.current.name !== 'analytics') {
                // アカウント詳細モーダルの場合、アカウントIDをセット
                if (!($scope.$parent.snsType === 'tiktok' && $scope.type === 'account_target')) {
                  extension = $scope.$parent.accountInfo
                    ? $scope.$parent.accountInfo.username || $scope.$parent.accountInfo.accountId
                    : $scope.accountUsername || $scope.accountId
                }
              }
              break
          }

          // CSVファイル名をセット
          switch (csvFile) {
            case 'post_facebook':
            case 'post_twitter':
            case 'post_instagram':
            case 'post_youtube':
            case 'post_line':
            case 'post_tiktok':
            case 'account_facebook':
            case 'account_twitter':
            case 'account_instagram':
            case 'account_youtube':
            case 'account_line':
            case 'account_tiktok':
            case 'tw_trendword':
            case 'brand_followers':
              $scope.csvDataFileName = csvFile
              break

            case 'event_facebook':
            case 'event_twitter':
            case 'event_instagram':
            case 'yahoo_word':
              $scope.csvDataFileName = csvFile + '_' + $scope.subName
              break

            case 'account_post':
              $scope.csvDataFileName = $scope.$parent.snsType + '_post'
              break
            case 'account_follower':
              if ($scope.snsType === 'facebook') {
                $scope.csvDataFileName = $scope.snsType + '_fan'
              } else {
                $scope.csvDataFileName = $scope.snsType + '_account_follower'
              }
              break

            default:
              $scope.csvDataFileName = $scope.$parent.snsType + '_' + csvFile

              if ($scope.$parent.snsType === 'tiktok' && $scope.type === 'account_target') {
                $scope.csvDataFileName += $scope.$parent.dataPerPostFlg ? '_average' : '_total'

                csvFile = $scope.$parent.snsType + '_' + csvFile
              }

              break
          }

          if (extension !== '') {
            $scope.csvDataFileName += '_' + extension
          }
          $scope.csvDataFileName += '.csv'
        }

        /**
         * CSVをダウンロードする際の処理
         * @return {object} CSVへ出力する内容
         */
        $scope.csvDownload = function () {
          $scope.isCsvDownloading = true
          $scope.tooltipMessage = 'CSVファイルの作成中..'

          const deferred = $q.defer()
          let request

          switch (csvFile) {
            case 'post_facebook':
            case 'post_twitter':
            case 'post_instagram':
            case 'post_youtube':
            case 'post_line':
            case 'post_tiktok':
              // 投稿のCSVのデータを取得
              request = csvDownloadService.Posts.download(
                $scope.$parent.selectedTab,
                $scope.$parent.getOptions
              )
              break

            case 'account_facebook':
            case 'account_twitter':
            case 'account_instagram':
            case 'account_youtube':
            case 'account_line':
            case 'account_tiktok':
              // アカウントのCSVのデータを取得
              request = csvDownloadService.Accounts.download($scope.$parent.selectedTab, {
                data: $scope.$parent.sortAccounts,
                dataPerPost: $scope.$parent.dataPerPost,
              })
              break

            case 'event_facebook':
            case 'event_twitter':
            case 'event_instagram':
            case 'event_youtube':
            case 'event_line':
              // イベントのCSVのデータを取得
              request = csvDownloadService.Posts.download($scope.snsType, $scope.$parent.getOptions)
              break

            case 'account_plays':
              // 再生回数グラフのCSVのデータを取得
              request = csvDownloadService.Accounts.accountChangeDownload(
                'plays',
                $scope.$parent.snsType,
                $scope.$parent.ttPlaysPerPostFlg,
                $scope.$parent.respondConfig.xAxis.csvPeriodArray,
                $scope.$parent.playsObject
              )
              break

            case 'account_respond':
              // 反応数グラフのCSVのデータを取得
              request = csvDownloadService.Accounts.accountChangeDownload(
                'respond',
                $scope.$parent.snsType,
                $scope.$parent.dataPerPostFlg,
                $scope.$parent.respondConfig.xAxis.csvPeriodArray,
                $scope.$parent.engagementObject
              )
              break

            case 'account_impressions':
              // インプレッショングラフのCSVのデータを取得
              request = csvDownloadService.Accounts.accountChangeDownload(
                'impressions',
                $scope.$parent.snsType,
                $scope.$parent.dataImpressionsPerPostFlg,
                $scope.$parent.impressionsConfig.xAxis.csvPeriodArray,
                $scope.$parent.impressionsConfig.series[0].data
              )

              break

            case 'account_respond_rate':
              // 反応率のCSVのデータを取得
              request = csvDownloadService.Accounts.accountChangeDownload(
                'respond_rate',
                $scope.$parent.snsType,
                $scope.$parent.dataPerPostFlg,
                $scope.$parent.respondRateConfig.xAxis.csvPeriodArray,
                $scope.$parent.respondRateConfig.series[0].data
              )
              break

            case 'account_post_count':
              // 1アカウントあたりのフラグ(default:false)
              let dataPerAccountFlg = false

              // 分析画面の場合、1アカウントあたりのフラグをセット
              if ($state.current !== undefined && $state.current.name === 'analytics') {
                dataPerAccountFlg = $scope.$parent.dataPerAccountFlg
              }

              // 反応率のCSVのデータを取得
              request = csvDownloadService.Accounts.accountChangeDownload(
                'post_count',
                $scope.$parent.snsType,
                dataPerAccountFlg,
                $scope.$parent.postCountConfig.xAxis.csvPeriodArray,
                $scope.$parent.postsObject
              )
              break

            case 'account_views':
              // Youtube:視聴回数のCSVデータを取得
              request = csvDownloadService.Accounts.accountChangeDownload(
                'account_views',
                $scope.$parent.snsType,
                $scope.$parent.youtubePerPostFlg.views,
                $scope.$parent.youtubeGraphConfig.views.xAxis.csvPeriodArray,
                $scope.$parent.youtubeGraphData.views
              )
              break

            case 'account_likes':
              // Youtube:高く評価のCSVデータを取得
              request = csvDownloadService.Accounts.accountChangeDownload(
                'account_likes',
                $scope.$parent.snsType,
                $scope.$parent.youtubePerPostFlg.likes,
                $scope.$parent.youtubeGraphConfig.likes.xAxis.csvPeriodArray,
                $scope.$parent.youtubeGraphData.likes
              )
              break

            case 'account_dislikes':
              // Youtube:低く評価のCSVデータを取得
              request = csvDownloadService.Accounts.accountChangeDownload(
                'account_dislikes',
                $scope.$parent.snsType,
                $scope.$parent.youtubePerPostFlg.dislikes,
                $scope.$parent.youtubeGraphConfig.dislikes.xAxis.csvPeriodArray,
                $scope.$parent.youtubeGraphData.dislikes
              )
              break

            case 'account_comments':
              // Youtube:コメントのCSVデータを取得
              request = csvDownloadService.Accounts.accountChangeDownload(
                'account_comments',
                $scope.$parent.snsType,
                $scope.$parent.youtubePerPostFlg.comments,
                $scope.$parent.youtubeGraphConfig.comments.xAxis.csvPeriodArray,
                $scope.$parent.youtubeGraphData.comments
              )
              break

            case 'account_follower':
              // フォロワー数のCSVのデータを取得
              request = csvDownloadService.Accounts.accountFollowersDownload(
                $scope.accountFollowerConfig.xAxis.csvPeriodArray,
                $scope.accountFollowerConfig.series[0].data,
                $scope.snsType
              )
              break

            case 'account_target_type':
            case 'tiktok_post_type':
            case 'account_target_characterNumber':
              // 投稿の対象(タイプ、文字数)のCSVのデータを取得
              request = csvDownloadService.Accounts.accountTargetDownload(
                $scope.analyticsTab,
                $scope.$parent.snsType,
                $scope.$parent.dataPerPostFlg,
                $scope.$parent.analyticsData.analytics
              )
              break

            case 'account_target_hashtag':
            case 'tiktok_post_hashtag':
              // 投稿の対象(ハッシュタグ)のCSVのデータを取得
              request = csvDownloadService.Accounts.accountHashtagDownload(
                $scope.$parent.snsType,
                $scope.$parent.dataPerPostFlg,
                $scope.$parent.getOptions
              )
              break

            case 'account_target_videoDuration':
              // 投稿の対象(動画秒数)のCSVのデータを取得
              request = csvDownloadService.Accounts.accountTargetDownload(
                $scope.analyticsTab,
                $scope.$parent.snsType,
                $scope.$parent.dataPerPostFlg,
                $scope.$parent.analyticsData.analytics
              )
              break

            case 'account_post':
              const params = $scope.$parent.paramsPostList
                ? $scope.$parent.paramsPostList
                : $scope.accountPostParams

              if (!params) {
                return
              }
              // アカウント詳細画面の投稿のCSVのデータを取得
              request = csvDownloadService.Posts.download($scope.$parent.snsType, params)
              break

            case 'tw_trendword':
              // トレンドワードのCSVデータを取得
              request = csvDownloadService.trendWords.download($scope.$parent.getOptions)
              break

            case 'yahoo_word':
              // Yahoo!検索ワードのCSVデータを取得
              request = csvDownloadService.yahooWords.download(
                $scope.$parent.yahooWordTab,
                $scope.$parent.getOptions
              )
              break

            case 'brand_followers':
              // ブランドのCSVデータを取得
              const filter = {
                categoryName: $scope.$parent.categoryName,
                subCategoryName: $scope.$parent.subCategoryName,
                keywordFilter: $scope.$parent.keywordFilter,
              }

              request = csvDownloadService.Brands.download(
                $scope.$parent.allBrands,
                $scope.$parent.query.order,
                filter
              )
              break

            default:
              return
          }

          // データが存在する場合はCSVデータをng-csvに渡し、アニメーションを戻す
          // データが存在しない場合は、ng-csvにデータを渡さず、アニメーションを戻す
          request
            .then((result) => {
              $scope.isCsvDownloading = false
              $scope.tooltipMessage = 'CSVダウンロード'
              deferred.resolve(result)
            })
            .catch(() => {
              $scope.isCsvDownloading = false
              $scope.tooltipMessage = 'CSVダウンロード'
            })

          // CSVファイルの形式をPromiseにてリターン
          return deferred.promise
        }
      },
    }
  })
